import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { Paragraph, TextLink } from 'ui-components';
import { Creator } from '~/clientApi/creator.model';
import { routes } from '~/core/router';

export function PlatformChartsCaptionSTMPredictionText({
  creator,
}: {
  creator?: Creator;
}) {
  const router = useRouter();

  const redirectToConnectPlatformsPage = useCallback(async () => {
    if (creator?.slug) {
      await router.push(
        {
          pathname: routes.talentProfilePlatformConnections(creator.slug),
          query: { creatorSlug: creator.slug },
        },
        undefined,
        { shallow: true },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creator?.slug]);

  return (
    <Paragraph sx={{ marginTop: 'spacing-200' }} size="sm" color="primary.300">
      Estimated based on similar creators.{' '}
      {creator?.slug && (
        <TextLink size="sm" onClick={redirectToConnectPlatformsPage}>
          Connect to enable verified metrics
        </TextLink>
      )}
      .
    </Paragraph>
  );
}
